import {
  GetAccessTokenFunc,
  GetIdTokenHintFunc
} from '@digital-services/shell';

import { fetcher } from '@/utils/swr-utils';

import { ID_TOKEN_HINT_PATH } from './paths';

export default function useGetIdTokenHint(): GetIdTokenHintFunc {
  const getIdTokenHint = async (
    getAccessToken: GetAccessTokenFunc,
    organizationId: string
  ) => {
    if (!getAccessToken) {
      throw new Error(
        'Authentication is not initialized or access token is unavailable'
      );
    }
    const response = await fetcher(
      ID_TOKEN_HINT_PATH(organizationId),
      getAccessToken
    );

    return response.idTokenHint;
  };

  return getIdTokenHint;
}
